import LineHeight125 from '@assets/icons/line-height-125.svg'
import { Icon } from './Icon'

export const LineHeight125Icon = Icon(LineHeight125)
